import React, { useState, useEffect } from "react";
import { Modal, Box, Button, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Confetti from "react-confetti";
import useWindowSize from "react-use/lib/useWindowSize";
import "./CertificateRegistrationSuccesPopup.css";
import { createPortal } from "react-dom";

const CertificateRegistrationSuccesPopup = ({
  open,
  onClose,
  imageUrl,
  onRedirect,
}) => {
  const [countdown, setCountdown] = useState(5);
  const { width, height } = useWindowSize();
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    if (open) {
      setShowConfetti(true);
      setCountdown(5);
    }
  }, [open]);

  useEffect(() => {
    if (!open || countdown <= 0) {
      if (countdown === 0) {
        handleRedirect();
      }
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown, open]);

  const handleRedirect = () => {
    setShowConfetti(false);
    if (onRedirect) {
      onRedirect();
    }
    if (onClose) {
      onClose();
    }
  };

  const handleConfettiComplete = () => {
    setShowConfetti(false);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        className="certificateRegistrationSuccesPopup__modal"
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
        style={{ zIndex: "1200" }}
      >
        <Box className="certificateRegistrationSuccesPopup__container">
          {showConfetti &&
            open &&
            createPortal(
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  zIndex: 1400,
                  pointerEvents: "none",
                }}
              >
                <Confetti
                  width={width}
                  height={height}
                  recycle={false}
                  numberOfPieces={700}
                  gravity={0.3}
                  initialVelocityY={25}
                  confettiSource={{
                    x: width / 100, // center horizontally
                    y: 0,
                    w: width,
                    h: 10,
                  }}
                  onConfettiComplete={handleConfettiComplete}
                />
              </div>,
              document.body
            )}
          <div className="certificateRegistrationSuccesPopup__content">
            <div className="certificateRegistrationSuccesPopup__iconWrapper">
              <CheckCircleIcon className="certificateRegistrationSuccesPopup__icon" />
            </div>

            <Typography
              id="success-modal-title"
              className="certificateRegistrationSuccesPopup__title"
            >
              Registration Successful!
            </Typography>

            <Typography
              id="success-modal-description"
              className="certificateRegistrationSuccesPopup__description"
            >
              Your certificate registration has been completed successfully.
            </Typography>

            <Button
              variant="contained"
              onClick={handleRedirect}
              className="certificateRegistrationSuccesPopup__button"
              fullWidth
            >
              Redirecting in {countdown} seconds to dashboard
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default CertificateRegistrationSuccesPopup;
